import { confirm } from "components/Confirmation"
import CustomDropzone from "components/CustomDropzone"
import { useEffect, useState } from "react"
import { Button, Modal, ModalBody } from "reactstrap"
import { alert } from "./Alert"

export default function ModalArquivo({ config, onClosed }) {
  const [file, setFile] = useState()

  useEffect(() => {
    setFile()
  }, [config])

  const handleChange = value => {
    setFile(value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!file) {
      alert({
        text: 'Você precisa selecionar uma foto',
      })
      return
    }

    confirm({
      header: "Alteração",
      text: "Tem certeza que gostaria de continuar?",
      onConfirm: async () => {
        if (config.onFileSelected) {
          await config.onFileSelected(file)
        }
        onClosed && onClosed()
      }
    })
  }

  return (
    <Modal isOpen={!!config}>
      <ModalBody>
        <h2>{config?.title}</h2>
        <hr />
        <form onSubmit={handleSubmit}>
          <CustomDropzone
            value={file}
            onChange={value => handleChange(value)}
            onRemove={() => handleChange(null)}
            edit={true}
          />
          <div className="text-right mt-4">
            <Button type="submit" color="primary">Salvar</Button>
            <Button type="button" color="primary" outline onClick={onClosed}>Cancelar</Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}